module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-times-event"
  }, [(_vm.showModal) ? _c('AppModal', {
    attrs: {
      "submitTxt": _vm.i18n[_vm.locale].btn,
      "isShowFooter": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].edit_times) + " " + _vm._s(_vm.lesson.title) + ", " + _vm._s(_vm._f("showDate")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
    staticClass: "form",
    attrs: {
      "slot": "body"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "origin-lesson"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].current_times))]), _vm._v(" "), _c('div', {
    staticClass: "flex border pad-10 relative"
  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times"
  }, [_c('div', [_vm._v(", kl. " + _vm._s(_vm.$filters.LT(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times__seperator"
  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$filters.LT(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
    staticClass: "marg-10-left"
  }, [_vm._v("\n            (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.oldDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n          ")])])]), _vm._v(" "), _c('h3', {
    staticClass: "marg-24-top flex align-center"
  }, [_c('span', {
    staticClass: "icon-clock"
  }), _c('span', {
    staticClass: "marg-5-left"
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale].new_times) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex align-center edit-times-input-wrapper"
  }, [_c('TimeChanger', {
    attrs: {
      "start": _vm.lesson.start,
      "end": _vm.lesson.end,
      "addClass": "edit-times-inputs"
    },
    on: {
      "updateStart": _vm.updateStartTime,
      "updateEnd": _vm.updateEndTime
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marg-10-left"
  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.newDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer modal-footer__flex"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-319c306a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsEventEditTimes.vue
// module id = 1840
// module chunks = 1